module.exports = __webpack_public_path__ + "img/oran_1kl.a5c77cc5.jpg";